import { jsonCopy } from '../../../utility/genericUtility';
import { datiReferenteTerzoInizializzato } from '../componentiBase/sezioniAnagrafica';

export const datiReferenteTerzo = jsonCopy(datiReferenteTerzoInizializzato);
